import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
export const leaseJourneyContext = createContext({});

const LeaseJourneyContextProvider = ({ children }) => {
  const [leaseJourneyData, setLeaseJourneyData] = useState({});
  const location = useLocation();

  useEffect(() => {
    if (location.state?.tenantLeadsData) {
      setLeaseJourneyData(location.state?.tenantLeadsData);
    }
  }, [location.state?.tenantLeadsData]);

  useEffect(() => {
    if (location.pathname !== '/home/lease-transaction-journey') {
      setLeaseJourneyData({});
    }
  }, [location.pathname]);
  return (
    <leaseJourneyContext.Provider value={{ leaseJourneyData }}>
      {children}
    </leaseJourneyContext.Provider>
  );
};

export default LeaseJourneyContextProvider;
